import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'ara-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {
  location: any;
  constructor(private translate: TranslateService, private baseService: BaseService, private loc: Location) {
    this.location = loc;
  }
  ngOnInit() {
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
  }
}